<!--

    MyResourcesPage.svelte
-->


<script>
    import { onMount } from 'svelte';
    import { push, replace } from 'svelte-spa-router';
    import { fade } from 'svelte/transition';
    import { fetchSavedServices, deleteSavedService } from '../../api/services.js';
    import { AccountStore } from "../../common/account.ts";
    import { setWarningAlert } from '../../stores/AlertsStore';
    import { masterSearch } from '../../common/master-objects.js';


    // TCARE components
    import MyResourcesBanner from '../../components/common/MyResourcesBanner.svelte';
    import MyServicesList from "../../components/lists/MyServicesList.svelte";
    import RemoveResourcePopup from '../../components/popups/RemoveResourcePopup.svelte';

    const FETCHING_SERVICES_MSG = 'Fetching your resources...';

    $: myServices = [];
    $: isFetchingServices = false;
    $: isShowingRemovePopup = false;
    $: popupResource = null;

    $: subtextMessage = getSubtextMessage(myServices);

    onMount( async () => {
        // console.log('');
        // console.log('MyResourcesPage onMount');

        if (!$AccountStore?.isLoggedIn) {
            replace('/landing');                                  // and login
            return;
        }

        await fetchMyServices();
        window.scrollTo(0, 0);          // do this for all other pages!
    })

    const fetchMyServices = async () => {
        isFetchingServices = true;
        const json = await fetchSavedServices();          // services.ts - must pass array
        isFetchingServices = false;

        if (json === null) {
            myServices = [];
            return;
        }

        if (json.errors) {
            setWarningAlert('Error fetching resources', 2000);
            return;
        }
        myServices = json;              // refresh the list
    }

    const removeResource = async (service) => {
        console.log('MyResourcesPage removeResource');
        console.log(service.id);

        let json = await deleteSavedService(service.id);
        if (json.errors) {
            // this could be a 404 - already deleted
            // setWarningAlert('Error deleting resource', 2000);
            // return;
            console.log('deleteSavedService ERROR');
        } else {
            console.log('deleteSavedService OK');
        }

        // do not set isFetchingServices to avoid screen flicker
        json = await fetchSavedServices();

        if (json === null) {
            myServices = [];
            return;
        }

        if (json.errors) {
            setWarningAlert('Error refreshing resources list', 2000);
            return;
        }
        myServices = json;              // refresh the list
    }
    
    const getSubtextMessage = (services) => {
        let msg = "";

        if (isFetchingServices) return msg;
        
        if (services.length <= 0) {
            msg = "You do not have any saved resources.";
            return msg;
        }

        if (services.length === 1) {
            msg = "Your saved resource is below. ";
        } else {
            msg = "Your " + services.length + " saved resources are below. ";
        }
        msg += "Connect with the resource for tailored assistance.";
        return msg;
    }


    // pass to and called by the list items
    const onShowPopup = (service) => {
        popupResource = service;
        isShowingRemovePopup = true;
    }

    const _onPopupCancel = () => {
        console.log('MyResourcesPage _onPopupCancel');
        isShowingRemovePopup = false;
    }
    
    const _onPopupConfirm = (service) => {
        console.log('MyResourcesPage _onPopupConfirm');
        isShowingRemovePopup = false;
        removeResource(service);
    }

</script>

<style>

    .my-resources-page .page-top {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }

    .sub-text     {
        color: var(--tcui-primary);
        font-size: 18px;
        font-weight: 500px;
        letter-spacing: 1.0px;
    }

    .my-resources-list {
        width: 80%;
        margin: auto;
        text-align: left;
        /* border: 1px solid green; */
    }

    .fetching-services {
        position: absolute;
        width: 100%;
        margin-top: 10vh;
        text-align: center;
        font-size: 30px;
        font-weight: 400;
        color: var(--tcui-primary);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- <div class="page-content" in:fly="{{ x: 200, duration: 500 }}" out:fade="{{ duration: 250 }}"> -->
<div class="page-content my-resources-page" >

    <div class="page-top">
        <div class="flex-row">
            <div class="spacer-h-25"></div>
        </div>

        <div class="flex-row">
            <MyResourcesBanner />  
            {#if !isFetchingServices}
                <div class="sub-text">{subtextMessage}</div>
            {/if}
        </div>

        <div class="flex-row">
            <div class="spacer-h-50"></div>
        </div>
    </div>

    {#if isFetchingServices}
        <div class="fetching-services" transition:fade >
            {FETCHING_SERVICES_MSG}
        </div>
    {:else}
        <div class="my-resources-list" in:fade >
            <MyServicesList services={myServices} {onShowPopup} />
        </div>
    {/if}

    <div class="spacer-h-50"></div>
</div>

{#if isShowingRemovePopup}
    <RemoveResourcePopup 
        onCancel={_onPopupCancel} 
        onConfirm={_onPopupConfirm} 
        resource={popupResource}
    />
{/if}
